import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { queryKeys } from '@queries/keys';
import { useQuery } from '@tanstack/react-query';
import { CommunitiesSelectDto, CommunitySelectDto } from '../types/api.types';

export const useGetCommunities = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<CommunitySelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<CommunitiesSelectDto>({
        path: '/v1/data/communities',
      });
      return result.communities;
    },
    queryKey: enabled ? queryKeys.community.getCommunities : queryKeys.placeholders.default,
  });
};
